import React, { useState } from "react";
import { supabase } from "./supabaseClient";

const C = {
  navy: "#1F3A5F",
  red: "#C0392B",
  midBlue: "#2E75B6",
  light: "#BFD3F0",
  bg: "#EDF1F7",
  text: "#1F3A5F",
  muted: "#6B7280",
  border: "#D6DEE8",
};

const FONT = "'Inter', system-ui, -apple-system, sans-serif";

export default function Login() {
  const [mode, setMode] = useState("signin"); // "signin" | "forgot"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  async function handleSignIn(e) {
    e.preventDefault();
    setError("");
    setInfo("");
    setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) setError(error.message);
  }

  async function handleForgot(e) {
    e.preventDefault();
    setError("");
    setInfo("");
    setBusy(true);
    const redirectTo = window.location.origin;
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
    setBusy(false);
    if (error) setError(error.message);
    else setInfo("Password reset email sent. Check your inbox.");
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: C.bg,
      fontFamily: FONT,
      display: "flex",
      flexDirection: "column",
    }}>
      {/* Header band */}
      <div style={{
        background: C.navy,
        color: "#fff",
        padding: "20px 32px",
        borderBottom: `4px solid ${C.red}`,
        display: "flex",
        alignItems: "center",
        gap: 20,
      }}>
        <img src="/esencee_logo.png" alt="Esencee Energy" style={{ height: 38, display: "block" }} />
        <div style={{ borderLeft: "1px solid rgba(255,255,255,0.2)", paddingLeft: 20 }}>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 0.3 }}>
            SolarSim Pro
          </div>
          <div style={{ fontSize: 12, color: C.light, marginTop: 2 }}>
            Engineering &amp; Business Development
          </div>
        </div>
      </div>

      {/* Form card */}
      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}>
        <form
          onSubmit={mode === "signin" ? handleSignIn : handleForgot}
          style={{
            width: "100%",
            maxWidth: 380,
            background: "#fff",
            border: `1px solid ${C.border}`,
            borderRadius: 6,
            padding: 28,
          }}
        >
          <h1 style={{
            margin: 0,
            marginBottom: 4,
            fontSize: 20,
            fontWeight: 700,
            color: C.navy,
          }}>
            {mode === "signin" ? "Sign in" : "Reset password"}
          </h1>
          <p style={{
            margin: 0,
            marginBottom: 20,
            fontSize: 12,
            color: C.muted,
          }}>
            {mode === "signin"
              ? "Use your Esencee account to continue."
              : "Enter your email and we'll send you a reset link."}
          </p>

          <label style={lblStyle}>Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            style={inputStyle}
          />

          {mode === "signin" && (
            <>
              <label style={lblStyle}>Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                style={inputStyle}
              />
            </>
          )}

          {error && (
            <div style={{
              marginTop: 12,
              padding: "8px 10px",
              background: "#FDECEC",
              border: `1px solid ${C.red}`,
              color: C.red,
              fontSize: 12,
              borderRadius: 4,
            }}>{error}</div>
          )}
          {info && (
            <div style={{
              marginTop: 12,
              padding: "8px 10px",
              background: "#E8F1FA",
              border: `1px solid ${C.midBlue}`,
              color: C.midBlue,
              fontSize: 12,
              borderRadius: 4,
            }}>{info}</div>
          )}

          <button
            type="submit"
            disabled={busy}
            style={{
              width: "100%",
              marginTop: 20,
              padding: "10px 14px",
              background: C.navy,
              color: "#fff",
              border: "none",
              borderRadius: 4,
              fontSize: 14,
              fontWeight: 500,
              fontFamily: FONT,
              cursor: busy ? "default" : "pointer",
              opacity: busy ? 0.6 : 1,
            }}
          >
            {busy
              ? "Working…"
              : mode === "signin"
              ? "Sign in"
              : "Send reset email"}
          </button>

          <div style={{ marginTop: 14, textAlign: "center" }}>
            <button
              type="button"
              onClick={() => {
                setMode(mode === "signin" ? "forgot" : "signin");
                setError("");
                setInfo("");
              }}
              style={{
                background: "none",
                border: "none",
                color: C.midBlue,
                fontSize: 12,
                fontFamily: FONT,
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              {mode === "signin" ? "Forgot password?" : "Back to sign in"}
            </button>
          </div>

          <div style={{
            marginTop: 24,
            paddingTop: 14,
            borderTop: `1px solid ${C.border}`,
            fontSize: 11,
            color: C.muted,
            textAlign: "center",
          }}>
            Engineering is truth. Mathematics is the language.
          </div>
        </form>
      </div>
    </div>
  );
}

const lblStyle = {
  display: "block",
  fontSize: 11,
  fontWeight: 500,
  color: C.text,
  marginTop: 12,
  marginBottom: 4,
  fontFamily: FONT,
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  border: `1px solid ${C.border}`,
  borderRadius: 4,
  fontSize: 14,
  fontFamily: FONT,
  boxSizing: "border-box",
  outline: "none",
};
